<!-- Filter Pills -->
@if (store.pills().length) {
	<div
		class="relative items-center hidden h-20 gap-2 px-8 mb-8 -mx-8 overflow-x-scroll lg:mx-0 lg:px-0 border-y sm:block"
	>
		<div class="absolute inset-0 flex h-10 gap-2 px-8 py-5 lg:px-0">
			@for (pill of store.pills(); track $index) {
				<uc-filter-pill
					[pillLabel]="pill.label"
					[urlKey]="pill.urlKey"
					[urlValue]="pill.urlValue"
					[removeActionDisabled]="pill.removeActionDisabled"
					(removeFilter)="removePill($event.urlKey, $event.urlValue)"
				/>
			}
		</div>
	</div>
}
